/* 🤖 this file was generated by svg-to-ts */
export const IconBigMediumDrucker: {
    name: 'big-medium-drucker';
    data: string;
} = {
    name: 'big-medium-drucker',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 128 128"><path d="M116 31H93V16a9 9 0 0 0-9-9H44a9 9 0 0 0-9 9v15H12a9 9 0 0 0-9 9v48a9 9 0 0 0 9 9h23v15a9 9 0 0 0 9 9h40a9 9 0 0 0 9-9V97h23a9 9 0 0 0 9-9V40a9 9 0 0 0-9-9M45 17h38v14H45zm38 94H45V73h38zm32-24H93V72a9 9 0 0 0-9-9H44a9 9 0 0 0-9 9v15H13V41h102z"/><circle cx="22" cy="51" r="4"/><circle cx="39" cy="51" r="4"/><path d="M73 81H54a4 4 0 0 0 0 8h19a4 4 0 0 0 0-8m0 15H54a4 4 0 0 0 0 8h19a4 4 0 0 0 0-8"/></svg>`,
};
